import Tooltip from "@material-ui/core/Tooltip";
import { useRecordContext } from "react-admin";

const VersionSetWarningField = (props) => {
  const record = useRecordContext(props);
  const warning = record?.[props.source];
  if (!warning) return <span>—</span>;

  return (
    <Tooltip title={<span style={{ whiteSpace: "pre-wrap" }}>{warning}</span>}>
      <span
        tabIndex={0}
        style={{ display: "block", maxWidth: 320, overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap" }}
      >
        {warning}
      </span>
    </Tooltip>
  );
};

export default VersionSetWarningField;
